import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useSearchParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NoAuthLayout, { StyledSubmissionInput, StyledSubmissionField } from '@Components/Layout/NoAuth';
import { useAppTheme } from '@Components/Context';
import { AppButton } from '@Components/Control';
import { updatePasswordRequest } from '@Actions';
import { paths } from '@Components/configs';

const RecoverAccountContent = ({
  small,
  isSignup = false,
  updatePassword,
  resetPasswordToken,
}) => {
  const { theme } = useAppTheme();
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    updatePassword(password, resetPasswordToken, paths.login);
  };

  const pageTitle = isSignup ? 'Set up your account' : 'Recover your account';
  const placeholder = isSignup ? 'Create a password' : 'New password';
  const submitMessage = isSignup ? 'Create Account' : 'Update Password';

  const submitDisabled = !password || !confirmPassword || password !== confirmPassword;

  return (
    <NoAuthLayout
      withBackButton
      seoConfig={null}
      title={pageTitle}
      small={small}
    >
      <StyledSubmissionField required name="password" htmlFor="password" type="password">
        <StyledSubmissionInput
          plain
          name="password"
          type="password"
          placeholder={placeholder}
          onChange={(e) => setPassword(e.target.value)}
          value={password}
        />
      </StyledSubmissionField>
      <StyledSubmissionField required name="confirmPassword" htmlFor="password" type="password">
        <StyledSubmissionInput
          plain
          name="confirmPassword"
          type="password"
          placeholder="Confirm password"
          onChange={(e) => setConfirmPassword(e.target.value)}
          value={confirmPassword}
        />
      </StyledSubmissionField>
      <AppButton
        overrideHover
        disabled={submitDisabled}
        onClick={handleSubmit}
        level="authSubmit"
        bgColor={theme.button.primaryBg}
        color={theme.button.primaryText}
        label={submitMessage}
        fontWeight={600}
        alignSelf="center"
      />
    </NoAuthLayout>
  );
};

RecoverAccountContent.propTypes = {
  small: PropTypes.bool.isRequired,
  resetPasswordToken: PropTypes.string.isRequired,
  updatePassword: PropTypes.func.isRequired,
  isSignup: PropTypes.bool,
};

const RecoverAccountPage = ({
  small, updatePassword,
}) => {
  const [searchParams] = useSearchParams();
  const recoveryToken = searchParams.get('reset_password_token');
  const signup = searchParams.get('account_setup');
  const isSignup = signup && (parseInt(signup, 10) === 1);

  if (recoveryToken && !isSignup) {
    return (
      <RecoverAccountContent
        small={small}
        resetPasswordToken={recoveryToken}
        updatePassword={updatePassword}
      />
    );
  }

  if (recoveryToken && isSignup) {
    return (
      <RecoverAccountContent
        isSignup
        small={small}
        resetPasswordToken={recoveryToken}
        updatePassword={updatePassword}
      />
    );
  }

  return <Navigate to={paths.root} />;
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updatePassword: updatePasswordRequest }, dispatch);
}

RecoverAccountPage.propTypes = {
  small: PropTypes.bool.isRequired,
  updatePassword: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(RecoverAccountPage);
